export default __webpack_public_path__ + "static/media/www.codinghumans.xyz.0e8579de.png";